import { render } from "./Quiz.vue?vue&type=template&id=6f44e3a0&ts=true"
import script from "./Quiz.vue?vue&type=script&lang=ts"
export * from "./Quiz.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__